import {CombinedState, combineReducers, Reducer} from 'redux';
import answerReducer from '../services/answerService/answer/reducer';
import {AnswerState} from '../services/answerService/answer/types';
import getAnswerStatusReducer from '../services/answerService/getAnswerStatus/reducer';
import {GetAnswerStatusState} from '../services/answerService/getAnswerStatus/types';
import pickedAnswerReducer from '../services/answerService/pickedAnswer/reducer';
import {PickedAnswerState} from '../services/answerService/pickedAnswer/types';
import validateOtpReducer from '../services/answerService/validateOtp/reducer';
import {ValidateOtpState} from '../services/answerService/validateOtp/types';
import setApiErrorReducer from '../services/appService/setApiError/reducer';
import {SetApiErrorState} from '../services/appService/setApiError/types';
import setAppMountedReducer from '../services/appService/setAppMounted/reducer';
import {SetAppMountedState} from '../services/appService/setAppMounted/types';
import setMeReducer from '../services/appService/setMe/reducer';
import {SetMeState} from '../services/appService/setMe/types';
import setPathnameReducer from '../services/appService/setPathname/reducer';
import {SetPathnameState} from '../services/appService/setPathname/types';
import loginReducer from '../services/authService/login/reducer';
import {LoginState} from '../services/authService/login/types';
import deleteCardReducer from '../services/cardService/deleteCard/reducer';
import {DeleteCardState} from '../services/cardService/deleteCard/types';
import apiEventReducer from '../services/eventService/apiEvent/reducer';
import {ApiEventState} from '../services/eventService/apiEvent/types';
import setRemoteConfigReducer from '../services/firebaseService/setRemoteConfig/reducer';
import {SetRemoteConfigState} from '../services/firebaseService/setRemoteConfig/types';
import contactReducer from '../services/miscService/contact/reducer';
import {ContactState} from '../services/miscService/contact/types';
import uploadReducer from '../services/miscService/upload/reducer';
import {UploadState} from '../services/miscService/upload/types';
import getCurrentQuestionReducer from '../services/questionService/getCurrentQuestion/reducer';
import {GetCurrentQuestionState} from '../services/questionService/getCurrentQuestion/types';
import getScoreboardReducer from '../services/scoreboardService/getScoreboard/reducer';
import {GetScoreboardState} from '../services/scoreboardService/getScoreboard/types';
import acceptEtkReducer from '../services/userService/acceptEtk/reducer';
import {AcceptEtkState} from '../services/userService/acceptEtk/types';
import getMeReducer from '../services/userService/getMe/reducer';
import {GetMeState} from '../services/userService/getMe/types';
import rewardConsumeReducer from '../services/userRewardService/rewardConsume/reducer';
import {RewardConsumeState} from '../services/userRewardService/rewardConsume/types';

export interface IStore {
  // ANSWER
  answer: AnswerState;
  getAnswerStatus: GetAnswerStatusState;
  pickedAnswer: PickedAnswerState;
  validateOtp: ValidateOtpState;
  // APP
  setApiError: SetApiErrorState;
  setAppMounted: SetAppMountedState;
  setMe: SetMeState;
  setPathname: SetPathnameState;
  // AUTH
  login: LoginState;
  // CARD
  deleteCard: DeleteCardState;
  // EVENT
  apiEvent: ApiEventState;
  // FIREBASE
  setRemoteConfig: SetRemoteConfigState;
  // MISC
  contact: ContactState;
  upload: UploadState;
  // QUESTION
  getCurrentQuestion: GetCurrentQuestionState;
  // SCOREBOARD
  getScoreboard: GetScoreboardState;
  // USER
  acceptEtk: AcceptEtkState;
  getMe: GetMeState;
  // USERREWARD
  rewardConsume: RewardConsumeState;
}

export const rootReducer: Reducer<CombinedState<IStore>> = combineReducers({
  // ANSWER
  answer: answerReducer,
  getAnswerStatus: getAnswerStatusReducer,
  pickedAnswer: pickedAnswerReducer,
  validateOtp: validateOtpReducer,
  // APP
  setApiError: setApiErrorReducer,
  setAppMounted: setAppMountedReducer,
  setMe: setMeReducer,
  setPathname: setPathnameReducer,
  // AUTH
  login: loginReducer,
  // CARD
  deleteCard: deleteCardReducer,
  // EVENT
  apiEvent: apiEventReducer,
  // FIREBASE
  setRemoteConfig: setRemoteConfigReducer,
  // MISC
  contact: contactReducer,
  upload: uploadReducer,
  // QUESTION
  getCurrentQuestion: getCurrentQuestionReducer,
  // SCOREBOARD
  getScoreboard: getScoreboardReducer,
  // USER
  acceptEtk: acceptEtkReducer,
  getMe: getMeReducer,
  // USERREWARD
  rewardConsume: rewardConsumeReducer,
})
